
import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
//
import PaymentsAndUpdates from './../../mixins/payments_and_updates.js'; //  PaymentsAndUpdates == Resources
import Preset from './../../mixins/preset.js'; //preset
import CNpaymentModal from './../../templates/CNpaymentModal/index.vue' //payent modal
import CNpaymentModalProcess from './../../templates/CNpaymentModal/script.js' //payent modal

let service = new services();

export default {
name: 'CNPayments',
mixins: [Preset, CNpaymentModalProcess],//,PaymentAndUpdate],
data () {
    return {
        user:{},
        payment:{},
        set_payment_data:{},
        set_payment_object:{},
        payment_details_data:{},
        component_view:{},
        amount_topay:0,

        //
        disable_btn: false,
        current_wallet_balance: 0,
        loggedIn: false,
        //
        payment_message:'',
        service_payment_ref: '',
        token_key:0,
        data_plan_payment_data: {},
        show_done: false,
    }
},
components: {
    'second-header': SecondHeader,
    'main-footer': MainFooter,
    "cnpayment-modal": CNpaymentModal
},
computed: {},
methods: {
    //settings
    setComponentView(view,attr1,attr2){
        this.component_view = {};
        this.component_view[view] = true;
        this.jumpToView('topp02');
    },

    getIncomingRequest(){
        //get route params
        if((this.$route.query.pay) && (this.$route.query.pay > 0)){
            this.pay_type = this.$route.query.pay;
        }
        if((this.$route.query.re) && (this.$route.query.re != '')){
            this.service_payment_ref = this.$route.query.re;
        }
        if((this.$route.query.no) && (this.$route.query.no != '')){
            this.token_key = this.$route.query.no;
            localStorage.setItem("cityneeds_call_src",2);//call from app
            this.setPreset();
        }
    },


    //preps
    setPreset(){
        service.authTokenKey(this, this.token_key).then(data => {
            if(data.body.status == 200) {
                //set token
                let self = this;
                localStorage.setItem("cityneeds_token",data.body.data_key);
                localStorage.setItem("cityneeds_token_key", this.token_key);
                setTimeout(function (){
                    self.preset();
                    setTimeout(function (){
                        self.xreset();
                    }, 10);
                }, 10);
            }else{
                this.payment_message = "Sorry, could not find payment details.";
            }
        }).catch((err) => { })
    },

    xreset(){
        this.$router.push('cnpayments?pay=3&re='+this.service_payment_ref+'&no='+this.token_key);
    }
},


created: function(){
    this.getIncomingRequest();
}

}


// WEBPACK FOOTER //
// ./src/components/CNProcesses/script.js